module.exports = __webpack_public_path__ + "static/media/rugby.0f43cd9b.jpg";